/*
 * @Author: Dom
 * @Date: 2022-05-30 15:49:05
 * @LastEditTime: 2022-06-13 14:17:07
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\views\account\recharge\service.ts
 */
import request from '@/utils/request'
import { TableListQueryParams } from './data.d'
import qs from 'qs'

//查询账号充值记录信息-分页
export async function getAccountRechargeFlowPageList(params: TableListQueryParams): Promise<any> {
    return request({
      url: '/seller/v1/accountRechargeFlow/getAccountRechargeFlowPageList',
      method: 'post',
      data: params,
    })
}
